<template>
    <div class="accountApp acccont">
        <div class="acctit zi2">
            {{$t('account.account')}}
            <div class="addbtn btnn">
                <el-popover
                        placement="bottom"
                        width="80"
                        trigger="click">
                    <div class="lanlist">
                        <div :class="lang==item.name?'activeList':''" @click="changlang(item.name, item)"
                             v-for="(item, index) in langList" :key="index">
                            <img :src="item.flag"/>{{item.full_name}}
                        </div>
                    </div>
                    <div slot="reference"><img :src="currentLang.flag"/>{{currentLang.full_name}}</div>
                </el-popover>
            </div>
        </div>
        <div class="flexbox fle-sb hebo">
            <div class="flex2 zi2">
                <div class="flexbox texal annhead">
                    <img src="../../assets/imgs/logo.png">
                    <div class="acn">
                        <div>{{user.username ? user.username : 'Welcome'}}</div>
                        <div class="sma colory" v-if="user.grade_id > 0"><i class="el-icon-medal-1"></i>VIP{{user.grade_id}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="zi2">
                <div class="sjbtn" @click="jumplevelup()"><i class="el-icon-medal-1"></i>{{$t('account.vip_up_level')}}
                </div>
            </div>
            <div class="posiab" v-if="user.grade_id > 0">
                <div class="flexbox fle-wrap">
                  <div class="item5">{{$t('account.time_remaining2')}} <span class="colory">{{countDownTime}}</span></div>
                </div>
            </div>
        </div>
        <div class="flexbox fle-sa wreibox">
            <div class="item5 ">
                <span class="colory "><span class="fontw">{{user.daily_money}}</span>USDT</span>
                <div>{{$t('account.daily_money_left2')}} </div>
            </div>
          <div class="linhe"></div>
            <div class="item5 bordr">
                <span class="colory"><span class="fontw">{{user.month_money}}</span>USDT</span>
                <div>{{$t('account.month_money_left2')}} </div>
            </div>
        </div>
        <div class="bagbox zi2">
            <div class="bgbl flexbox fle-sb">
                <img src="../../assets/imgs/qd.png">
                <div class="texal flex2 padl">
                    <div class="colory fontw">{{user.money}}USDT<span class="minim"> ≈ ${{user.money}}</span></div>
                    <div>{{$t('account.balance')}}</div>
                    <div class="colory fontw posrbtn" v-if="!user.user_id" @click="$router.push({path: '/login'})">
                        {{$t('account.login')}}
                    </div>
                </div>
            </div>
            <div class="flexbox fle-sb">
                <div class="item bgb" @click="jumpinvestMoney">
                    <i class="el-icon-s-finance"></i>
                    <div class="tip">{{$t('account.recharge')}}</div>
                </div>
                <div class="item bgb" @click="jumpcash">
                    <i class="el-icon-coin"></i>
                    <div class="tip">{{$t('account.withdrawal')}}</div>
                </div>
                <div class="item bgb" @click="jumptransfer">
                    <i class="el-icon-money"></i>
                    <div class="tip">{{$t('account.transfer')}}</div>
                </div>
            </div>
        </div>
        <div class="msgbar" @click="jumpmsg">
            <div class="msgring flexbox">
                <div class="fnts" v-if="unread > 0">
                    <el-badge is-dot class="item">
                        <i class="el-icon-message-solid colorb"></i>
                    </el-badge>
                </div>
                <div class="fnts" v-else>
                    <i class="el-icon-message-solid colorb"></i>
                </div>
                <div class="flex2 fontw tex2en">{{message}}</div>
            </div>
        </div>
        <div class="otherbox">
            <div class="texal">{{$t('account.services')}}</div>
            <div class="flexbox fle-ar fle-wrap otherboxcont">
                <div class="fnts2" @click="jumpMngmny">
                    <i class="el-icon-s-finance colorb"></i>
                    <div>{{$t('account.financing')}}</div>
                </div>
                <div class="fnts2" @click="jumpacSave">
                    <i class="el-icon-user-solid colorb"></i>
                    <div>{{$t('account.security')}}</div>
                </div>
                <div class="fnts2" @click="jumpmsg">
                    <i class="el-icon-message-solid colorb"></i>
                    <div>{{$t('account.message')}}</div>
                </div>
                <div class="fnts2" @click="showEmail">
                    <i class="el-icon-service colorb"></i>
                    <div>{{$t('account.contact')}}</div>
                </div>
                <div class="fnts2" @click="jumpQuestion">
                    <i class="el-icon-question colorb"></i>
                    <div>{{$t('account.question')}}</div>
                </div>
                <div class="fnts2" @click="jumpMoneyBags">
                    <i class="el-icon-wallet colorb"></i>
                    <div>{{$t('account.wallet')}}</div>
                </div>
                <div class="fnts2" @click="logout">
                    <i class="el-icon-switch-button colorb"></i>
                    <div>{{$t('account.logout')}}</div>
                </div>
            </div>
        </div>
        <el-dialog :title="$t('account.contact')" :modal='false' :visible.sync="dialogVisible" width="70%"
                   :append-to-body="false">
            <span>{{$t('account.contact_service')}}{{customer_service_email}}</span>
        </el-dialog>
    </div>
</template>
<script>

    import Cookies from 'js-cookie'
    import {getInfo} from '@/api/account'

    export default {
        name: 'accountApp',
        data() {
            return {
                user: {
                    user_id: -1,
                    username: '',
                    money: '0.00',
                    grade_id: 0,
                    daily_money: 0,
                    month_money: 0,
                },
                leftVipTime: '',
                countDownTime: '',
                countDownFn: null,
                customer_service_email: '',
                message: '',
                dialogVisible: false,
                lang: Cookies.get('lang'),
                langList: [],
                currentLang: {},
                unread: 0,
            }
        },
        computed: {

            routeName() {
                console.log(this.$route.path)
                return this.$route.path
            },
        },
        created() {
            if (!this.isApp()) {
                this.$router.replace('/home/account')
            } else {
                this.getData()
            }

        },
        destroyed() {
            clearInterval(this.countDownFn); //清除定时器
        },
        methods: {
            isApp() {
                return document.documentElement.clientWidth < 800 ? true : false
            },
            getData() {
                getInfo().then(res => {
                    const data = res.data
                    this.user = data.user
                    this.customer_service_email = data.customer_service_email
                    this.message = data.message,
                        this.unread = data.unread,
                        this.langList = res.data.langList
                    if (this.langList) {
                        for (let index = 0; index < this.langList.length; index++) {
                            let item = this.langList[index]
                            if (this.lang == item.name) {
                                this.currentLang = item
                                break
                            }
                        }
                    }
                    this.leftVipTime = res.data.leftVipTime;
                    if (this.leftVipTime) {
                        this.countDown();
                    }

                }).catch(_ => {

                })
            },
            countDownFun(time) {
                // console.log(time)
                let startTime = new Date(); //当前时间
                let end = new Date(time); //结束时间
                // console.log(end)
                let result = parseInt((end - startTime) / 1000); //计算出豪秒
                let d = parseInt(result / (24 * 60 * 60)); //用总共的秒数除以1天的秒数
                let h = parseInt((result / (60 * 60)) % 24); //精确小时，用去余
                let m = parseInt((result / 60) % 60); //剩余分钟就是用1小时等于60分钟进行趣余
                let s = parseInt(result % 60);
                //当倒计时结束时，改变内容
                if (result <= 0) {
                    return 0
                }
                if (h < 10) {
                    h = "0" + h
                }
                if (m < 10) {
                    m = "0" + m
                }
                if (s < 10) {
                    s = "0" + s
                }
                if (h == 0 && m == 0) {
                    return s + "s"
                } else if (h == 0) {
                    return m + ":" + s
                } else if (d == 0) {
                    return h + ":" + m + ":" + s
                } else {
                    if (d > 1) {
                        return d + this.$t('account.days') + h + ":" + m + ":" + s
                    } else {
                        return d + this.$t('account.day') + h + ":" + m + ":" + s
                    }
                }
            },

            // 定时器
            countDown() {
                let that = this;
                that.countDownFn = setInterval(() => {
                    //  console.log(that.countDownFun(item.leftVipTime))
                    let html = that.countDownFun(that.countDownTime)
                    if (html === 0) {
                        that.leftVipTime = ''
                        clearInterval(that.countDownFn); //清除定时器
                        that.getData()
                    } else {
                        that.countDownTime = that.countDownFun(that.leftVipTime)
                    }
                }, 1000)
            },
            changlang(lang, item) {
                if (lang != this.lang) {
                    this.lang = lang
                    this.currentLang = item
                    this.$i18n.locale = lang
                    Cookies.set('lang', lang)
                    Cookies.set('lang_var', item.lang_var)
                    this.$router.go(0)
                }
            },
            returnpage() {
                this.$router.go(-1)
            },
            jumpmsg() {
                this.$router.push({path: '/home/msglist'})
            },
            jumplevelup() {
                this.$router.push({path: '/home/levelup'})
            },
            jumpMngmny() {
                this.$router.push({path: '/home/myMoneyManage'})
            },
            jumpacSave() {
                this.$router.push({path: '/home/acSave'})
            },
            jumpMoneyBags() {
                this.$router.push({path: '/home/moneyBag'})
            },
            jumpinvestMoney() {
                this.$router.push({path: '/home/investMoney'})
            },
            jumpcash() {
                this.$router.push({path: '/home/cash'})
            },
            jumptransfer() {
                this.$router.push({path: '/home/transfer'})
            },
            jumpQuestion() {
                this.$router.push({path: '/home/questions'})
            },
            logout() {
                this.$router.push({path: '/login'})
            },
            showEmail() {
                this.$alert(this.$t('account.contact_service')+this.customer_service_email, this.$t('account.contact'), {
                    confirmButtonText: this.$t('account.trader_confirm'),
                    customClass: 'message-logout',
                    callback: action => {
                    }
                });
            },
        }
    }
</script>
<style>
    @media (max-width: 730px) {
        .message-logout {
            width: 92% !important;
        }
    }
</style>
<style lang="scss" scoped>
    .accountApp {
      .wreibox{
        width: 90%;
        margin: 0px auto;
        padding-top: 10px;
        position: relative;
      }
        .el-dialog__body {
            padding: 10px;
        }

        .item4 {
            width: 40%;
        }
        .linhe{
          width: 1px;
          height: 40px;
          background: #2b62a1;
        }
        .item5{
          font-size: 12px;
          line-height:20px;
          .fontw{
            padding-right: 4px;
            font-size: 18px;
          }
        }

        .tex2en {
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2; // 2行
        }

        &.acccont {
            font-size: 16px;
            padding-bottom: 60px;

            &::before {
                position: absolute;
                content: '';
                width: 100%;
                height: 300px;
                z-index: 0;
                left: 0px;
                background: url('../../assets/imgs/bgb.png');
                background-size: 100% 100%;
            }

            .zi2 {
                z-index: 2;
                position: relative;

                .sjbtn {
                    padding: 4px 6px;
                    font-size: 13px;
                    background: rgba($color: #000000, $alpha: 0.2);
                }
            }

            .acctit {
                border-bottom: 0px;
                background: #000;

                .addbtn {
                    background: #000 !important;
                }

                img {
                    width: 30px;
                    height: 20px;
                    vertical-align: middle;
                    margin-right: 6px;
                }
            }

            .hebo {
                padding: 20px 20px 30px 20px;
                box-sizing: border-box;
                position: relative;
                border-bottom: 1px solid #2b62a1;
                .posiab {
                    position: absolute;
                    bottom: 0px;
                    left: 104px;
                    top: 84px;
                    &.colory {
                        font-size: 14px;
                    }
                }
            }

            .bagbox {
                width: 94%;
                margin: 20px auto;
                background: #2a2a2a;
                padding: 20px 20px;
                box-sizing: border-box;
                border-radius: 4px;

                img {
                    width: 50px;
                    height: auto;
                }

                .fontw {
                    font-size: 22px;
                    line-height: 30px;
                    padding-bottom: 10px;
                    font-weight: bold;
                }

                .item {
                    margin-top: 14px;
                    background: rgb(49, 46, 228);
                    width: 30%;
                    padding: 3px 0px;
                    font-size: 20px;
                    border-radius: 4px;

                    .tip {
                        font-size: 14px;
                        line-height: 18px;
                    }
                }
            }

            .msgbar {
                width: 94%;
                margin: 20px auto;
                background: #2a2a2a;
                padding: 20px 10px;
                box-sizing: border-box;
                border-radius: 4px;

                .msgring {
                    justify-content: flex-start;
                }

                .fnts {
                    font-size: 26px;
                }
            }

            .otherbox {
                .texal {
                    padding-left: 10px;
                }

                .fnts2 {
                    margin: 10px 0px;
                    width: 24%;
                    font-size: 12px;

                    .colorb {
                        font-size: 24px;
                    }
                }

                .otherboxcont {
                    width: 94%;
                    margin: 20px auto;
                    background: #2a2a2a;
                    padding: 10px 10px;
                    box-sizing: border-box;
                    border-radius: 4px;
                }
            }

            .annhead {
                justify-content: flex-start;

                .acn {
                    font-size: 22px;
                    line-height: 30px;

                    .sma {
                        font-size: 14px;
                    }

                    .colory {
                        font-size: 16px;
                    }
                }

                img {
                    width: 60px;
                    height: 60px;
                    padding-right: 20px;
                }
            }
        }
    }
</style>
